import { useState } from "react";
import { Flag } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import api, { apiErr } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { toast } from "sonner";

export function ReportButton({ postId, commentId = null, size = "sm" }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const reasons = [
    { key: "spam", label: t("comm.rSpam") },
    { key: "harassment", label: t("comm.rHarass") },
    { key: "harmful", label: t("comm.rHarmful") },
    { key: "misinfo", label: t("comm.rMisinfo") },
    { key: "other", label: t("comm.rOther") },
  ];

  const submit = async (reason) => {
    setBusy(true);
    try {
      await api.post("/community/report", { post_id: postId, comment_id: commentId, reason });
      toast.success(t("comm.reportThanks"));
      setOpen(false);
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  const iconCls = size === "xs" ? "h-3 w-3" : "h-3.5 w-3.5";
  const btnCls = size === "xs" ? "h-6 w-6" : "h-7 w-7";

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          data-testid={commentId ? `report-comment-${commentId}` : `report-post-${postId}`}
          title={t("comm.report")}
          className={`flex ${btnCls} items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-accent/60 hover:text-foreground`}
        >
          <Flag className={iconCls} strokeWidth={1.5} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-56 rounded-2xl p-2" data-testid="report-menu">
        <p className="px-2 py-1.5 text-xs font-medium text-muted-foreground">{t("comm.reportTitle")}</p>
        {reasons.map((r) => (
          <button
            key={r.key}
            disabled={busy}
            onClick={() => submit(r.key)}
            data-testid={`report-reason-${r.key}`}
            className="w-full rounded-xl px-2 py-2 text-left text-sm transition-colors hover:bg-accent/60 disabled:opacity-50"
          >
            {r.label}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
